import { AppRoutes } from "./routs";
import { AppRoutesProps } from "./types";
import Main from "../../Main";
import { VideoPage } from "../../modules/video";
import React from "react";
import { VideoStoreProvider } from "../provider/VideoStoreProvider";

export const routeConfig: Record<AppRoutes, AppRoutesProps> = {
    [AppRoutes.MAIN]: {
        path: "main",
        element: <Main />,
        authOnly: true,
    },
    [AppRoutes.LOGIN]: {
        path: "login",
        element: null,
        authOnly: true,
    },
    [AppRoutes.VIDEO]: {
        path: "video",
        element: (
            <VideoStoreProvider>
                <VideoPage />
            </VideoStoreProvider>
        ),
        authOnly: true,
    },
    // last
    [AppRoutes.NOT_FOUND]: {
        path: "*",
        element: <div>404</div>,
    },
};
